import React, { useContext, useEffect } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tabs } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import Analytics from '../../../utils/analytics'
import { InstitutionGroupContext } from '../../../Providers/InstitutionGroupProvider'
import { getUser } from '../../../reducers/UserReducer'
import InternshipsReporting from './InternshipsReporting'

const { TabPane } = Tabs

const mapStateToProps = state => {
  return {
    user: getUser(state.getUser),
    t: getTranslate(state.locale)
  }
}

const ReportingView = ({ user, t }) => {
  const institutionGroupContext = useContext(InstitutionGroupContext)

  useEffect(() => {
    Analytics.pageView('/institution-badge')
  }, [])

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon='user' style={{ marginTop: '3px' }} />
            <div className='h-spacing' />
            {t('View assistants informations')}
          </div>
        }
      >
        <InternshipsReporting institutions={institutionGroupContext?.institutions} />
      </TabPane>
    </Tabs>
  )
}

export default connect(mapStateToProps)(ReportingView)
